export const updateFaviconWithCounter = (unreadCount: number): void => {
  const favicon = document.querySelector("link[rel='icon']") as HTMLLinkElement;

  // Base favicon URL (your default favicon)
  const baseFavicon = "/favicon-64x64.png"; // Replace with your favicon URL

  // Create a canvas
  const canvas = document.createElement("canvas");
  const size = 32; // Canvas size
  canvas.width = size;
  canvas.height = size;
  const ctx = canvas.getContext("2d");

  if (!ctx) return;

  // Draw the base favicon
  const img = new Image();
  img.src = baseFavicon;

  img.onload = () => {
    // Draw the base favicon onto the canvas
    ctx.clearRect(0, 0, size, size);
    ctx.drawImage(img, 0, 0, size, size);

    // Add the unread counter circle
    if (unreadCount > 0) {
      const circleSize = 10;
      ctx.fillStyle = "#c10606"; // Red background for the counter
      ctx.beginPath();
      ctx.arc(size - circleSize, 22, circleSize, 0, 2 * Math.PI);
      ctx.fill();

      const fontSize = 9;
      // Draw the unread count number
      ctx.fillStyle = "#FFFFFF"; // White text
      ctx.font = `${fontSize*2}px Arial`;
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillText(
        unreadCount > 99 ? "99+" : unreadCount.toString(),
        size - circleSize,
        24
      );
    }

    // Update the favicon
    if (favicon) {
      favicon.href = canvas.toDataURL("image/png");
    }
  };
};